import * as replacementValuesActions from '../actions/replacement-values.actions';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { copy } from '../../../../shared/utils/functions/copy.function';
import { update } from '../../../shared/store/crud-functions';

export interface ReplacementValuesState {
  replacementValues: any;
  loading: boolean;
  loaded: boolean;
  totalInsuranceValues: any;
  updateSuccess: boolean;
  deleteSuccess: boolean;
  addSuccess: boolean;
  error: string;
}

const initialState = {
  replacementValues: null,
  loading: false,
  loaded: false,
  totalInsuranceValues: null,
  updateSuccess: null,
  deleteSuccess: null,
  addSuccess: null,
  error: null
};

export const replacementValuesReducer = (state = initialState, action) => {
  switch (action.type) {
    case replacementValuesActions.GET_REPLACEMENT_VALUES_LIST:
      return {
        ...state,
        error: null,
        loading: true,
        loaded: state.loaded,
      };
    case replacementValuesActions.GET_REPLACEMENT_VALUES_LIST_SUCCESS:
      return {
        ...state,
        error: null,
        replacementValues: action.payload,
        loading: false,
        loaded: true,
      };
    case replacementValuesActions.GET_REPLACEMENT_VALUES_LIST_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
        loaded: false,
      };
    case replacementValuesActions.UPDATE_REPLACEMENT_VALUES_SUCCESS:
      const replacementValue = action.payload;
      const replacementValues = update(state.replacementValues, replacementValue, 'buildingId');
      return {
        ...state,
        error: null,
        replacementValues: replacementValues,
        loading: state.loading,
        loaded: state.loaded,
        updateSuccess: true
      };
    case replacementValuesActions.UPDATE_REPLACEMENT_VALUES_FAIL:
      return {
        ...state,
        error: action.payload,
        updateSuccess: false
      };
    case replacementValuesActions.RESET_REPLACEMENT_VALUES_CRUD:
      return {
        ...state,
        error: null,
        updateSuccess: null
      };
    case replacementValuesActions.GET_TOTAL_INSURANCE_VALUES_LIST:
      return {
        ...state,
        error: null,
        loading: true,
        loaded: state.loaded,
      };
    case replacementValuesActions.GET_TOTAL_INSURANCE_VALUES_LIST_SUCCESS:
      return {
        ...state,
        error: null,
        totalInsuranceValues: action.payload,
        loading: false,
        loaded: true,
      };
    case replacementValuesActions.GET_TOTAL_INSURANCE_VALUES_LIST_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
        loaded: false,
      };
    case replacementValuesActions.CLEAR_REPLACEMENT_VALUES_LIST:
      return {
        ...state,
        error: null,
        replacementValues: null,
        loading: false,
        loaded: false
      };
    default:
      return state;
  }
};

export const getReplacementValuesState = createFeatureSelector<ReplacementValuesState>('replacementValuesReducer');

export const getReplacementValuesList = (state: ReplacementValuesState) => state.replacementValues;
export const getReplacementValuesListLoaded = (state: ReplacementValuesState) => state.loaded;
export const getReplacementValuesUpdateStatus = (state: ReplacementValuesState) => state.updateSuccess;
export const getTotalInsuranceValuesList = (state: ReplacementValuesState) => state.totalInsuranceValues;
export const getTotalInsuranceValuesListLoaded = (state: ReplacementValuesState) => state.loaded;

export const getLastThreeYearsCRVCost = (state: ReplacementValuesState) =>
  state.totalInsuranceValues ?
    state.totalInsuranceValues.map(function (item) { return { "year": item.year, "totalCost": item.crvTotalCost }; }) :
    null;

export const getLastThreeYearsContentCost = (state: ReplacementValuesState) =>
  state.totalInsuranceValues ?
    state.totalInsuranceValues.map(function (item) { return { "year": item.year, "totalCost": item.contentsTotalCost }; }) :
    null;

export const getLastThreeYearsLibraryBooksCost = (state: ReplacementValuesState) =>
  state.totalInsuranceValues ?
    state.totalInsuranceValues.map(function (item) { return { "year": item.year, "totalCost": item.libraryBooksTotalCost }; }) :
    null;

export const getLastThreeYearsSpecEquipTotalCost = (state: ReplacementValuesState) =>
  state.totalInsuranceValues ?
    state.totalInsuranceValues.map(function (item) { return { "year": item.year, "totalCost": item.specEquipTotalCost }; }) :
    null;
